
import React, { Component } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row, Form, Button, Alert, Image } from "react-bootstrap";
import configData from "../../config.json";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validateProposerForm } from "./MotorCommonValidation";
import tatalogo from './tataaig.jpeg';

export default class MProposelsummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      requestId: sessionStorage.getItem("proposalrequest_Id"),
      buttondissable: false,
      idv: "",
      policypremium: "",
      integId: 328,
      exshowroomprice: "",
      net_premium: "",
      cpatenure: "",
      minimumIDV: "",
      maximumIDV: "",
      ex_showroom_price: "",
      proposal_id: "",
      proposer_salutation: "",
      proposer_fname: "",
      proposer_mname: "",
      proposer_lname: "",
      proposer_dob: null,
      startDate: new Date(),
      proposer_gender: "",
      proposer_marital: "",
      proposer_occupation: "",
      proposer_add1: "",
      proposer_add2: "",
      proposer_add3: "",
      proposer_state: "",
      proposer_pan: "",
      proposer_email: "",
      proposer_mobile: "",
      financier_type: "",
      financier_name: "",
      vehicle_chassis: "VBJRIR984959407654",
      vehicle_engine: "DFHKY58949588",
      vehicle_puc_declaration: "false",
      vehicle_puc: "",
      vehicle_puc_expiry: "",
      nominee_name: "",
      nominee_relation: "",
      nominee_age: "",
      appointee_name: "",
      bund_od_pol_number: "",
      bund_od_add: "",
      bund_od_insurer_name: "",
      bund_tp_pol_number: "",
      bund_tp_add: "",
      bund_tp_insurer_name: "",
      pre_insurer_name: "BAJAJ ALLIANZ GENERAL INSURANCE CO.LTD",
      pre_insurer_no: "87655454556767",
      pre_od_insurer_code: "BAJAJ ALLIANZ",
      pre_od_insurer_name: "BAJAJ ALLIANZ GENERAL INSURANCE CO.LTD",
      pre_od_policy_no: "301113283089100",
      pre_tp_insurer_code: "BAJAJ ALLIANZ",
      pre_tp_insurer_name: "BAJAJ ALLIANZ GENERAL INSURANCE CO.LTD",
      proposer_pincode: "400001",
      pre_tp_pol_no: "",
      carriedOutBy: "",
      __finalize: "1",
      ckycEnabled: false,
      // final_premium: 2824,
      isWaiting: false,
      waitTime: 10,
      // Add terms and conditions state
      termsAccepted: false,
      // Flags to prevent duplicate API calls
      isProposalResponseFetching: false,
      isPaymentGatewayProcessing: false,
    };
  }

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };

  // Handler for terms and conditions checkbox
  handleTermsChange = (e) => {
    this.setState({ termsAccepted: e.target.checked });
  };

  handleCustomerSubmitClick = (e) => {
    window.location.href = "/McustomerDetails";
  };

  handleSubmitvehicleinfoClick = (e) => {
    window.location.href = "/mvinfo";
  };

  handleSubmitQuoteClick = (e) => {
    window.location.href = "/MQuotes";
  };

  handleSubmitBackClick = (e) => {
    window.location.href = "/McustomerDetails";
  };

  handleproposer_salutationChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_salutation: fieldValue });
  };

  handleproposer_fnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_fname: fieldValue });
  };

  handleproposer_mnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_mname: fieldValue });
  };

  handleproposer_lnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_lname: fieldValue });
  };

  handleproposer_dobChange = (date) => {
    if (date) {
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

      this.setState({
        proposer_dob: formattedDate,
      });
    }
  };

  handleproposer_genderChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_gender: fieldValue });
  };

  handleproposer_maritalChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_marital: fieldValue });
  };

  handleproposer_occupationChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_occupation: fieldValue });
  };

  handleproposer_add1Change = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_add1: fieldValue });
  };

  handleproposer_add2Change = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_add2: fieldValue });
  };

  handleproposer_add3Change = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_add3: fieldValue });
  };

  handleproposer_stateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_state: fieldValue });
  };

  handleproposer_panChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === "proposer_pan") {
      const cleanedValue = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      this.setState({ proposer_pan: cleanedValue });
    }
  };

  handleproposer_emailChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_email: fieldValue });
  };

  handleproposer_mobileChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_mobile: fieldValue });
  };

  handlefinancier_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ financier_type: fieldValue });
  };

  handlefinancier_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ financier_name: fieldValue });
  };

  handlevehicle_chassisChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ vehicle_chassis: fieldValue });
  };

  handlevehicle_engineChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ vehicle_engine: fieldValue });
  };

  handlepre_insurer_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pre_insurer_name: fieldValue });
  };

  handlepre_insurer_noChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pre_insurer_no: fieldValue });
  };

  handlenominee_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ nominee_name: fieldValue });
  };

  handlenominee_relationChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ nominee_relation: fieldValue });
  };

  handlenominee_ageChange = (e) => {
    const input = e.target.value;
    const onlyNumbers = input.replace(/\D/g, "");

    if (onlyNumbers === "") {
      this.setState({ nominee_age: "" });
      return;
    }

    const numericValue = parseInt(onlyNumbers, 10);
    if (numericValue <= 100) {
      this.setState({ nominee_age: onlyNumbers });
    }
  };

  handleappointee_nameChange = (e) => {
    const fieldValue = e.target.value;
    this.setState({ appointee_name: fieldValue });
  };

  handleappointee_relationChange = (e) => {
    const fieldValue = e.target.value;
    this.setState({ appointee_relation: fieldValue });
  };

  handleSumbit = (e) => {
    e.preventDefault();

    // First check if terms and conditions are accepted
    if (!this.state.termsAccepted) {
      this.showToast("Please accept the Terms and Conditions to proceed", "error");
      return false;
    }

    const { isValid, errors } = validateProposerForm(this.state);

    if (!isValid) {
      const firstErrorKey = Object.keys(errors)[0];
      const firstErrorMessage = errors[firstErrorKey];
      this.showToast(firstErrorMessage, "error");
      return false;
    }

    var formData = new FormData();
    const jsonData = {
      proposal_id: sessionStorage.proposal_id,
      proposer_salutation: this.state.proposer_salutation,
      proposer_fname: this.state.proposer_fname,
      proposer_mname: this.state.proposer_mname,
      proposer_lname: this.state.proposer_lname,
      proposer_dob: this.state.proposer_dob,
      proposer_gender: this.state.proposer_gender,
      proposer_marital: this.state.proposer_marital,
      proposer_occupation: "SERVICE",
      proposer_add1: this.state.proposer_add1,
      proposer_add2: this.state.proposer_add2,
      proposer_add3: this.state.proposer_add3,
      proposer_state: this.state.proposer_state,
      proposer_pan: this.state.proposer_pan,
      proposer_email: this.state.proposer_email,
      proposer_mobile: this.state.proposer_mobile,
      financier_type: this.state.financier_type,
      financier_name: this.state.financier_name,
      vehicle_chassis: this.state.vehicle_chassis,
      vehicle_engine: this.state.vehicle_engine,
      vehicle_puc_declaration: this.state.vehicle_puc_declaration,
      vehicle_puc: this.state.vehicle_puc,
      vehicle_puc_expiry: this.state.vehicle_puc_expiry,
      nominee_name: this.state.nominee_name,
      nominee_relation: "Brother",
      nominee_age: parseInt(21),
      bund_od_pol_number: this.state.bund_od_pol_number,
      bund_od_add: this.state.bund_od_add,
      bund_od_insurer_name: this.state.bund_od_insurer_name,
      bund_tp_pol_number: this.state.bund_tp_pol_number,
      bund_tp_add: this.state.bund_tp_add,
      bund_tp_insurer_name: this.state.bund_tp_insurer_name,
      pre_insurer_name: this.state.pre_insurer_name,
      pre_insurer_no: this.state.pre_insurer_no,
      pre_od_insurer_code: this.state.pre_od_insurer_code,
      pre_od_insurer_name: this.state.pre_od_insurer_name,
      pre_od_policy_no: this.state.pre_od_policy_no,
      pre_tp_insurer_code: this.state.pre_tp_insurer_code,
      pre_tp_insurer_name: this.state.pre_tp_insurer_name,
      pre_tp_pol_no: this.state.pre_tp_pol_no,
      carriedOutBy: this.state.carriedOutBy,
      __finalize: "1",
    };

    const jsonData1 = JSON.stringify(jsonData);
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 328);
    formData.append("savedata", "yes");
    formData.append("jsonData", jsonData1);

    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Proposal Submission Response:", data);

        // Fixed: Check if data exists before accessing properties
        if (data && data.message) {
          this.showToast(data.message, data.status);
        }

        if (data && data.status === "success") {
          // Clear form state
          this.setState({
            plan_type: "",
            business_type: "",
            registrationNumber: "",
            customerType: "",
            prev_pol_start_date: "",
            prev_pol_end_date: "",
            mobileNumber: "",
          });

          // Store response data in session

          if (data.requestId) {
            sessionStorage.setItem("proposalrequest_Id", data.requestId);
          }

          // Start countdown and fetch proposal response
          this.setState({ isWaiting: true, waitTime: 20 });
          this.countdownInterval = setInterval(() => {
            this.setState((prevState) => {
              if (prevState.waitTime <= 1) {
                clearInterval(this.countdownInterval);
                this.proposalResponsejsonfetchHandler();
                return { isWaiting: false, waitTime: 0 };
              }
              return { waitTime: prevState.waitTime - 1 };
            });
          }, 1000);
        } else {
          toast.error(data?.message);
        }
      })

  };

  componentWillUnmount() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  proposalResponsejsonfetchHandler = () => {
    // Prevent duplicate calls
    if (this.state.isProposalResponseFetching) {
      return;
    }
    // Set flag to prevent duplicate calls
    this.setState({ isProposalResponseFetching: true });

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 328);
    formData.append("requestId", sessionStorage.proposalrequest_Id);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("Full API Response:", data);

        // Fixed: Check if data exists and has message before accessing
        if (data && (data.message || data.message_txt)) {
          this.showToast(data.message || data.message_txt, data.status || "info");
        }

        if (data && data.status === "success") {
          // Store cKYC request ID if available
          if (data.requestId) {
            sessionStorage.setItem("cKYCrequestId", data.requestId);
          }

          // Check if data structure is valid
          if (data.data && Array.isArray(data.data.data) && data.data.data.length > 0) {
            const responseData = data.data.data[0];
            if (responseData) {
              // Store all session data
              sessionStorage.setItem("quote_stage", responseData.quote_stage || "");
              sessionStorage.setItem("proposal_stage", responseData.proposal_stage || "");
              sessionStorage.setItem("proposal_no", responseData.proposal_no || "");
              sessionStorage.setItem("payment_id", responseData.payment_id || "");
              sessionStorage.setItem("policy_id", responseData.policy_id || "");

              // Enable CKYC button
              this.setState({ ckycEnabled: true });
              if (!this.state.isPaymentGatewayProcessing) { this.Handlepaymentgateway(); }


              if (!this.ckycTimeout) {
                this.ckycTimeout = setTimeout(() => {
                  this.HandleCKYC({ preventDefault: () => { } });
                }, 50000);
              }
            }
          } else {
            toast.warning("No proposal data received. Please contact support.");
          }
        } else {
          toast.error(data?.message || "Failed to fetch proposal response.");
        }
      })
      .finally(() => {
        this.setState({ isProposalResponseFetching: false });
      });
  };

  Handlepaymentgateway = (e) => {
    if (e) e.preventDefault();

    // Prevent duplicate calls
    if (this.state.isPaymentGatewayProcessing) {
      console.log("⚠️ Payment gateway already processing. Skipping duplicate call.");
      return;
    }

    // Set flag to prevent duplicate calls
    this.setState({ isPaymentGatewayProcessing: true });
    console.log("🔄 Payment gateway processing started...");

    const jsonData = {
      payment_mode: "onlinePayment",
      online_payment_mode: "UPI",
      payer_type: "Customer",
      product_code: 3187,
      payer_id: "",
      payer_pan_no: this.state.proposer_pan,
      payer_name: `${this.state.proposer_fname} ${this.state.proposer_lname}`,
      payer_relationship: "",
      email: this.state.proposer_email,
      office_location_code: 90101,
      deposit_in: "Bank",
      pan_no: this.state.proposer_pan,
      payment_id: [sessionStorage.getItem("payment_id")],
      returnurl: "https://dev-app.apnapolicy.co.in/mpolicydownload",
    };
    const jsonData11 = JSON.stringify(jsonData);

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 362);
    formData.append("savedata", "yes");
    formData.append("jsonData", JSON.stringify(jsonData11));

    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {


        // Fixed: Check if data and message exist before showing toast
        if (data && data.message) {
          this.showToast(data.message, data.status);
        }

        if (data && data.status === "success") {
          // Store request ID if available
          if (data.requestId) {
            sessionStorage.setItem("proposalPaymentrequest_Id", data.requestId);
          }

          // Fixed: Check if data.data exists before accessing message_txt
          if (data.data && data.data.message_txt) {
            toast.success(data.data.message_txt);
          }

          // Fixed: Check if data.data exists before checking status
          if (data.data && data.data.status && data.data.status < 0) {
            this.setState({ isPaymentGatewayProcessing: false });
            this.HandlePayment();
            return;
          }

          // Parse and redirect to payment URL
          if (data.data?.data) {
            try {
              const innerData = JSON.parse(data.data.data);
              const paymentUrl = innerData?.url;

              if (paymentUrl) {
                console.log("✅ Payment URL received. Redirecting...");
                // Don't reset flag here as we're redirecting
                window.location.href = paymentUrl;
              } else {
                toast.error("Payment URL not found in response.");
                this.setState({ isPaymentGatewayProcessing: false });
              }
            } catch (err) {
              console.error("Error parsing payment data:", err);
              toast.error("Error processing payment URL.");
              this.setState({ isPaymentGatewayProcessing: false });
            }
          } else {
            toast.warning("No payment data received. Please try again.");
            this.setState({ isPaymentGatewayProcessing: false });
          }
        } else {
          toast.error(data?.message || "Payment gateway setup failed.");
          this.setState({ isPaymentGatewayProcessing: false });
        }
      })
      .catch((error) => {
        console.error("Payment Gateway Error:", error);
        toast.error("Something went wrong while setting up payment. Please try again.");
        this.setState({ isPaymentGatewayProcessing: false });
      });
  };

  HandleCKYC = (e) => {
    if (e) e.preventDefault();
    window.location = "./mckyc";
  };

  HandlePayment = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 362);
    formData.append("requestId", sessionStorage.proposalPaymentrequest_Id);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data);
        this.showToast(data.message_txt || data.message, true);

        if (
          data.status === "success" &&
          data.data?.status === 200 &&
          data.data?.data
        ) {
          try {
            const parsedInnerData = JSON.parse(data.data.data);
            const paymentUrl = parsedInnerData?.url;

            if (paymentUrl) {
              window.location.href = paymentUrl;
            } else {
              toast.error("Payment URL not found.");
            }
          } catch (err) {
            console.error("Parsing error:", err);
            toast.error("Error parsing payment URL.");
          }
        } else {
          toast.error("Payment initiation failed.");
        }
      })
      .catch((error) => {
        // console.error("Fetch error:", error);
        // toast.error("Something went wrong while initiating payment.");
      });

  };

  render() {
    const { nominee_age, appointee_name, appointee_relation, termsAccepted } = this.state;
    const previousYearStart = new Date();
    previousYearStart.setFullYear(previousYearStart.getFullYear() - 100);
    previousYearStart.setMonth(0);
    previousYearStart.setDate(1);

    return (
      <div>
        <Row className="mb-2 ">
          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Quotes</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive ">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Vehicle Info</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div
              className="widget_BG widget_BG_grid bi bi-file-person nav-icon"
              onClick={this.handleSubmitBackClick}
            >
              <p
                className="nav-label mt-2"
                onClick={this.handleSubmitBackClick}
              >
                Customer Details
              </p>
            </div>
          </Col>
          <Col className="col-md-3 active-page">
            <div className="widget_BG widget_BG_grid fill nav-icon bi bi-journal-check">
              <p className="nav-label mt-2">Proposal Summary</p>
            </div>
          </Col>
        </Row>

        <Row className="widget_BG widget_BG_grid d-flex m-0 mt-2">
          <h4>Review Proposal</h4>
          <Image style={{ width: "auto", height: "100px" }}
            src={tatalogo}
            alt="" />
          <Col md="2" lg="2">
            <Form.Group controlId="policyType">
              <Form.Label>Title</Form.Label>
              <Form.Control
                as="select"
                value={this.state.proposer_salutation}
                onChange={this.handleproposer_salutationChange}
              >
                <option value="">Select</option>
                <option value="Ms">Ms</option>
                <option value="Mr">Mr</option>
                <option value="mrs">Mrs</option>
                <option value="miss">Miss</option>
                <option value="dr">Dr</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="proposer_fname"
                id="proposer_fname"
                value={this.state.proposer_fname}
                onChange={this.handleproposer_fnameChange}
              />
            </Form.Group>
          </Col>
          <Col md="3" lg="3">
            <Form.Group>
              <Form.Label>Middle Name</Form.Label>
              <Form.Control
                type="text"
                name="proposer_mname"
                id="proposer_mname"
                value={this.state.proposer_mname}
                onChange={this.handleproposer_mnameChange}
              />
            </Form.Group>
          </Col>
          <Col md="3" lg="3">
            <Form.Group>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="proposer_lname"
                id="proposer_lname"
                value={this.state.proposer_lname}
                onChange={this.handleproposer_lnameChange}
              />
            </Form.Group>
          </Col>
          <Col md="3" lg="3">
            <Form.Group>
              <Form.Label>DOB</Form.Label>
              <div calendarClassName="custom-calendar">
                <DatePicker
                  name="proposer_dob"
                  dropdownMode="select"
                  dateFormat="dd/MM/yyyy"
                  showTimeSelect={false}
                  selected={this.state.proposer_dob}
                  onChange={(date) => this.handleproposer_dobChange(date)}
                  className="form-control"
                  id="proposer_dob"
                  placeholderText="Select Date of Birth"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  minDate={previousYearStart}
                  maxDate={new Date()}
                />
              </div>
            </Form.Group>
          </Col>
          <Col md="3" lg="3">
            <Form.Group controlId="policyType">
              <Form.Label>Gender</Form.Label>
              <Form.Control
                as="select"
                value={this.state.proposer_gender}
                onChange={this.handleproposer_genderChange}
              >
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Others">Others</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md="3" lg="3">
            <Form.Group controlId="policyType">
              <Form.Label>Marital Status</Form.Label>
              <Form.Control
                as="select"
                value={this.state.proposer_marital}
                onChange={this.handleproposer_maritalChange}
              >
                <option value="">Select</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Others">Others</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md="3" lg="3">
            <Form.Group controlId="policyType">
              <Form.Label>Occupation</Form.Label>
              <Form.Control
                as="select"
                value={this.state.proposer_occupation}
                onChange={this.handleproposer_occupationChange}
              >
                <option value="">Select</option>
                <option value="SERVICE" selected>
                  SERVICE
                </option>
                <option value="BUSINESS">BUSINESS</option>
                <option value="STUDENT">STUDENT</option>
                <option value="HOUSEWIFE">HOUSEWIFE</option>
                <option value="RETIRED">RETIRED</option>
                <option value="SELF-EMPLOYED">SELF-EMPLOYED</option>
                <option value="UNEMPLOYED">UNEMPLOYED</option>
                <option value="OTHERS">OTHERS</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>

        <Row className="widget_BG widget_BG_grid d-flex m-0 mt-2">
          <h4>Contact Details</h4>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Address 1</Form.Label>
              <Form.Control
                type="text"
                name="proposer_add1"
                id="proposer_add1"
                value={this.state.proposer_add1}
                onChange={this.handleproposer_add1Change}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Address 2</Form.Label>
              <Form.Control
                type="text"
                name="proposer_add2"
                id="proposer_add2"
                value={this.state.proposer_add2}
                onChange={this.handleproposer_add2Change}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Address 3</Form.Label>
              <Form.Control
                type="text"
                name="proposer_add3"
                id="proposer_add3"
                value={this.state.proposer_add3}
                onChange={this.handleproposer_add3Change}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="proposer_state"
                id="proposer_state"
                value={this.state.proposer_state}
                onChange={this.handleproposer_stateChange}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>PAN Number</Form.Label>
              <Form.Control
                type="text"
                name="proposer_pan"
                id="proposer_pan"
                maxLength={10}
                value={this.state.proposer_pan}
                onChange={this.handleproposer_panChange}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Email-ID</Form.Label>
              <Form.Control
                type="text"
                name="proposer_email"
                id="proposer_email"
                value={this.state.proposer_email}
                onChange={this.handleproposer_emailChange}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="text"
                name="proposer_mobile"
                id="proposer_mobile"
                maxLength={10}
                value={this.state.proposer_mobile}
                onChange={this.handleproposer_mobileChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="widget_BG widget_BG_grid d-flex m-0 mt-2">
          <h4>Vehicle Details</h4>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Vehicle chassis No</Form.Label>
              <Form.Control
                type="text"
                name="vehicle_chassis"
                id="vehicle_chassis"
                value={this.state.vehicle_chassis}
                onChange={this.handlevehicle_chassisChange}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Vehicle Engine No</Form.Label>
              <Form.Control
                type="text"
                name="vehicle_engine"
                id="vehicle_engine"
                value={this.state.vehicle_engine}
                onChange={this.handlevehicle_engineChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="widget_BG widget_BG_grid d-flex m-0 mt-2">
          <h4>Nominee Details</h4>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Nominee Name</Form.Label>
              <Form.Control
                type="text"
                name="nominee_name"
                id="nominee_name"
                value={this.state.nominee_name}
                onChange={this.handlenominee_nameChange}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Nominee Age</Form.Label>
              <div calendarClassName="custom-calendar">
                <Form.Control
                  type="text"
                  name="nominee_age"
                  id="nominee_age"
                  value={nominee_age}
                  inputMode="numeric"
                  pattern="\d*"
                  onChange={this.handlenominee_ageChange}
                />
              </div>
            </Form.Group>
          </Col>

          <Col lg="4" md="4">
            <Form.Group controlId="policyType">
              <Form.Label>Nominee Relation</Form.Label>
              <Form.Control
                as="select"
                value={this.state.nominee_relation}
                onChange={this.handlenominee_relationChange}
              >
                <option value="">Select</option>
                <option value="self">Self</option>
                <option value="spouse">Spouse</option>
                <option value="son">Son</option>
                <option value="daughter">Daughter</option>
                <option value="Brother">Brother</option>
              </Form.Control>
            </Form.Group>
          </Col>
          {this.state.nominee_age && parseInt(this.state.nominee_age) < 18 && (
            <>
              <Col md="4" lg="4">
                <Form.Group>
                  <Form.Label>Appointee Nominee Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="appointee_name"
                    id="appointee_name"
                    value={appointee_name}
                    onChange={this.handleappointee_nameChange}
                  />
                </Form.Group>
              </Col>
              <Col md="4" lg="4">
                <Form.Group>
                  <Form.Label>Appointee Nominee Relation</Form.Label>
                  <Form.Select
                    type="text"
                    name="appointee_relation"
                    id="appointee_relation"
                    value={appointee_relation}
                    onChange={this.handleappointee_relationChange}
                  >
                    <option value="">Select</option>
                    <option value="self">Self</option>
                    <option value="spouse">Spouse</option>
                    <option value="son">Son</option>
                    <option value="daughter">Daughter</option>
                    <option value="Brother">Brother</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </>
          )}
        </Row>

        <Row className="widget_BG widget_BG_grid d-flex m-0 mt-2">
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Previous Insurer Name</Form.Label>
              <Form.Control
                type="text"
                name="pre_insurer_name"
                id="pre_insurer_name"
                value={this.state.pre_insurer_name}
                onChange={this.handlepre_insurer_nameChange}
              />
            </Form.Group>
          </Col>
          <Col md="4" lg="4">
            <Form.Group>
              <Form.Label>Previous Policy Number</Form.Label>
              <Form.Control
                type="text"
                name="pre_insurer_no"
                id="pre_insurer_no"
                value={this.state.pre_insurer_no}
                onChange={this.handlepre_insurer_noChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Terms and Conditions Section */}
        <Row className="widget_BG widget_BG_grid d-flex m-0 mt-2">
          <h4>Terms and Conditions</h4>
          <Col md="12">
            <Alert variant="light" className="p-3 mb-3" style={{ backgroundColor: "#f8f9fa", border: "1px solid #dee2e6" }}>
              <div className="terms-content" style={{ maxHeight: "200px", overflowY: "auto", fontSize: "14px", lineHeight: "1.5" }}>
                <h6>Important Terms and Conditions:</h6>
                <ul className="mb-2">
                  <li>I declare that all the information provided in this proposal is true and complete to the best of my knowledge.</li>
                  <li>I understand that any misstatement or concealment of material facts may void my insurance policy.</li>
                  <li>I agree to pay the premium as quoted and understand that coverage begins only after payment confirmation.</li>
                  <li>I understand that this insurance is subject to the terms, conditions, and exclusions mentioned in the policy document.</li>
                  <li>I confirm that I have read and understood the policy wordings, terms, and conditions.</li>
                  <li>I understand that the vehicle described in this proposal is in good condition and roadworthy.</li>
                  <li>I agree to notify the company immediately of any changes in the risk or circumstances affecting this insurance.</li>
                  <li>I understand that claims will be settled as per the policy terms and conditions.</li>
                </ul>
                <p className="mb-0 small text-muted">
                  By checking the box below, I confirm that I have read, understood, and agree to abide by all the terms and conditions mentioned above and in the policy document.
                </p>
              </div>
            </Alert>

            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                id="termsAccepted"
                label={
                  <span>
                    I have read and agree to the{" "}
                    <strong>Terms and Conditions</strong> mentioned above
                    <span className="text-danger"> *</span>
                  </span>
                }
                checked={termsAccepted}
                onChange={this.handleTermsChange}
                className="fs-6"
              />
            </Form.Group>

            {/* Show validation message if terms not accepted */}
            {!termsAccepted && (
              <Alert variant="warning" className="small">
                Please accept the Terms and Conditions to proceed with your proposal submission.
              </Alert>
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              style={{ float: "right" }}
              variant="primary"
              className={`m-1 mt-3 rounded-0 ${!termsAccepted ? 'opacity-50' : ''}`}
              onClick={this.handleSumbit}
              disabled={!termsAccepted || this.state.isWaiting}
            >
              {this.state.isWaiting
                ? `Please wait... (${this.state.waitTime}s)`
                : "Submit"}
            </Button>
            <Button
              style={{ float: "right" }}
              variant="primary"
              className="m-1 mt-3 rounded-0"
              disabled={!this.state.ckycEnabled}
              onClick={this.HandleCKYC}
            >
              CKYC
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}